import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function LinkInterceptor() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleGlobalClick = (e) => {
      const anchor = e.target.closest('a');
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href) return;

      const target = anchor.getAttribute('target');
      if (target === '_blank') return;

      const isLocal = href.includes('.html') || href.startsWith('/') || href.startsWith('./') || href.startsWith('#') || href === '';
      const isExternal = href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:') || href.startsWith('tel:');

      if (isLocal && !isExternal) {
        e.preventDefault();
        
        let route = href;
        if (route.startsWith('./')) {
          route = route.slice(2);
        }
        
        // Separate hash
        let hash = '';
        const hashIdx = route.indexOf('#');
        if (hashIdx !== -1) {
          hash = route.substring(hashIdx);
          route = route.substring(0, hashIdx);
        }

        const routeMap = {
          'index.html': '/',
          '/index.html': '/',
          'about.html': '/about',
          '/about.html': '/about',
          'services.html': '/services',
          '/services.html': '/services',
          'team.html': '/team',
          '/team.html': '/team',
          'blog.html': '/blog',
          '/blog.html': '/blog',
          'contact.html': '/contact',
          '/contact.html': '/contact',
          'terms.html': '/terms',
          '/terms.html': '/terms',
          'service-branding.html': '/services/branding',
          '/service-branding.html': '/services/branding',
          'service-social-media.html': '/services/digital-marketing',
          '/service-social-media.html': '/services/digital-marketing',
          'service-web-development.html': '/services/web-development',
          '/service-web-development.html': '/services/web-development',
          'service-3d-event-design.html': '/services/3d-event-design',
          '/service-3d-event-design.html': '/services/3d-event-design',
          'service-video-animation.html': '/services/video-animation',
          '/service-video-animation.html': '/services/video-animation',
          'service-seo.html': '/services/seo-ai-solutions',
          '/service-seo.html': '/services/seo-ai-solutions',
          'blog-branding-vs-logo.html': '/blog/branding-vs-logo',
          '/blog-branding-vs-logo.html': '/blog/branding-vs-logo',
          'blog-local-seo-dubai.html': '/blog/local-seo-dubai',
          '/blog-local-seo-dubai.html': '/blog/local-seo-dubai',
          'blog-website-speed-conversions.html': '/blog/website-speed',
          '/blog-website-speed-conversions.html': '/blog/website-speed',
          'blog-social-media-roi.html': '/blog/social-media-roi',
          '/blog-social-media-roi.html': '/blog/social-media-roi',
          'blog-exhibition-stand-mistakes.html': '/blog/exhibition-stand-mistakes',
          '/blog-exhibition-stand-mistakes.html': '/blog/exhibition-stand-mistakes',
          'blog-animation-for-conversions.html': '/blog/animation-conversions',
          '/blog-animation-for-conversions.html': '/blog/animation-conversions',
        };

        if (routeMap[route]) {
          route = routeMap[route];
        } else {
          // General cleanup
          if (route.endsWith('.html')) {
            route = route.slice(0, -5);
          }
          if (route !== '/' && route !== '' && !route.startsWith('/')) {
            route = '/' + route;
          }
        }

        // Navigate with hash
        navigate(route + hash);
      }
    };

    document.addEventListener('click', handleGlobalClick);
    return () => document.removeEventListener('click', handleGlobalClick);
  }, [navigate]);

  return null;
}
